import usePaginatedList, { type PaginatedListResult } from './use-paginated-list';
import {
  type CustomerOrderListItemDto,
  toCustomerOrder,
} from '../dto/customer-order/customer-order-list-item-dto';
import { type CustomerOrder } from '../entities';
import { CUSTOMER_ORDER_END_POINT_URL } from '../utils/endpoints';

export interface CustomerOrdersListParams {
  id?: string;
  orderDateFrom?: string;
  orderDateTo?: string;
  customerIds?: number[];
  siteIds?: number[];
  page: number;
  size: number;
}

export type CustomerOrdersListResult = PaginatedListResult<CustomerOrder>;

/**
 * Loads a page of the customer orders which the current user can read, from the customer order controller.
 * It loads again whenever the content of "params" changes or "refetch" is called. A failed load clears the list and
 * sets "errorMessage".
 */
const useCustomerOrdersList = (params: CustomerOrdersListParams): CustomerOrdersListResult =>
  usePaginatedList<CustomerOrderListItemDto, CustomerOrder>(
    CUSTOMER_ORDER_END_POINT_URL,
    params,
    toCustomerOrder,
    'Failed to load orders'
  );

export default useCustomerOrdersList;
